<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,Interpretive Kiosks and Structures"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Examples of possible kiosk configurations and interpretive sign structures.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img kiosks-80-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/interpretive-kiosk-with-durareader-signs.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img kiosks-113-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/roofed-interpretive-kiosk.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img kiosks-80-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/custom-kiosk.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img kiosks-57-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/custom-steel-kiosk.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img kiosks-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/custom-stone-gateway-sign.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img kiosks-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/kiosks/custom-weathering-steel-wayfinding-sign.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Interpretive Kiosks and Structures'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Kiosks.vue